<script setup lang="ts">
import { Star } from 'lucide-vue-next';
import { customersTestimonials } from '@app/types';

interface Review {
  name: string;
  role: string;
  text: string;
  rating: number;
}

</script>

<template>
  <section id="testimonials" class="py-16 lg:py-24 bg-pink-50">
    <div class="max-w-8xl sm:mx-16 mx-6 sm:px-6 ">
      <h2 class="text-3xl md:text-5xl font-black text-center text-slate-900 mb-10 sm:mb-16">מי שכבר איתנו, לא מבין איך הוא לא עשה את זה קודם.</h2>

      <div class="grid md:grid-cols-4 gap-4 sm:gap-6">
        <div v-for="(review, i) in customersTestimonials.filter(x => x.review)" :key="i" class="bg-white p-6 sm:p-8 rounded-3xl shadow-sm border border-slate-100">
          <div class="flex gap-1 mb-4">
            <Star v-for="j in 5" :key="j" class="w-4 h-4 sm:w-5 sm:h-5 fill-yellow-400 text-yellow-400" />
          </div>
          <p class="text-slate-700 text-sm sm:text mb-6 leading-relaxed">"{{ review.review }}"</p>
          <div class="flex items-center gap-4">
            <div class="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-pink-200 to-purple-200 rounded-full flex items-center justify-center font-bold text-slate-700 text-sm sm:text-base">
              {{ review.name.charAt(0) }}
            </div>
            <div>
              <h4 class="font-bold text-slate-900 text-sm sm:text-base">{{ review.name }}</h4>
              <p class="text-xs sm:text-sm text-slate-500">{{ review.business }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
